/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-26 18:01:48
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-15 13:18:17
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Checkbox/Checkbox.tsx
 */
import { Checkbox } from 'antd';
import React from 'react';
import css from './css.module.less';
// interface IProps {
//   className?: string;
//   checked: boolean;
//   onChange: (checked, e) => void;
//
// }
const Check = (props) => {
  const { className, children, checked, onChange, disabled, ...rest } = props;
  return (
    <Checkbox
      className={className}
      checked={checked}
      onChange={(e) => {
        if (onChange) onChange(e.target.checked, e);
      }}
      disabled={disabled}
      {...rest}>
      {children}
    </Checkbox>
  );
};

const CheckboxGroup = (props) => {
  const { checks = [], disabled, ...rest } = props;
  return (
    <Checkbox.Group disabled={disabled} {...rest}>
      {checks.map((check) => {
        const { label, value, ...rest } = check;
        return (
          <Check {...rest} value={value} key={value}>
            {label}
          </Check>
        );
      })}
    </Checkbox.Group>
  );
};
export { CheckboxGroup, OriCheckbox };
export default Check;
const OriCheckboxGroup = (props) => {
  const { children, ...rest } = props;
  return <Checkbox.Group {...rest}>{children}</Checkbox.Group>;
};
const OriCheckbox = (props) => {
  const { children, className, disabled, ...rest } = props;
  return (
    <Checkbox
      className={`${css.checkbox} ${className || ''}`}
      disabled={disabled}
      {...rest}>
      {children}
    </Checkbox>
  );
};
OriCheckbox.Group = OriCheckboxGroup;
